export default "__VITE_ASSET__Ce8qt7Hb__"